import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { UserRequestRole, UserResponse, UserSaved } from 'src/app/models/user.model';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';

@Component({
  selector: 'app-modal-create-user',
  templateUrl: './modal-create-user.component.html',
  styleUrls: ['./modal-create-user.component.scss']
})
export class ModalCreateUserComponent {
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  @Output() close = new EventEmitter<any>();
  name = "";
  email = "";
  timeout = null;
  errorMessageEmail = null;
  newUser: UserRequestRole = new UserRequestRole();
  currentCompany = null;
  actualUser: UserSaved = null;

  constructor(
    private roleService: RolesAndPermissionsService,
    private toastService: ToastrService,
    private authService: AuthenticationService
  ) {
    this.actualUser = this.authService.getUser();
  }

  createUser() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    this.errorMessageEmail = "";
    this.authService.setCurrentCompanyId(809);
    this.roleService.checkEmail(this.newUser.email, 809).subscribe({
      next: (response: ResponseObject) => {
        var permissions = { companies: [], email: '', admin: true, userPartner: this.actualUser.contadorGT};
        permissions.email = this.newUser.email;
        var newCompany = { id: 809, roles: [] };
        newCompany.roles.push(2000);
        permissions.companies.push(newCompany);
        this.roleService.saveUserOnOldTable(permissions).subscribe({
          next: (response: ResponseObject) => {
            this.toastService.success("Se agregó correctamente al usuario");
            this.buttonSave.loading = false;
            this.authService.clearCompany();
            this.close.emit(this.newUser);
          },
          error: (error: HttpErrorResponse) => {
            this.buttonSave.loading = false;
            this.authService.clearCompany();
            this.toastService.error(error.error.message);
          }
        })
      },
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.authService.clearCompany();
        this.errorMessageEmail = error.error.message;
      }
    })
  }
}
